export { default as App }                   from './App.js';
export { default as WindowEvents }          from './WindowEvents.js';
export { default as LockScroll }            from './LockScroll.js';
export { default as Video }                 from './Video.js';
export { default as Graphics }              from './Graphics.js';
export { default as ScrollbarWidth }        from './ScrollbarWidth.js';
export { default as Slider }                from './Slider.js';
export { default as Maps }                  from './Maps.js';
export { default as Persons }               from './Persons.js';
export { default as Popup }                 from './Popup.js';
export { default as ProductionPage }        from './ProductionPage.js';
export { default as UI }                    from './UI.js';
export { default as Header }                from './Header.js';
export { default as News }                  from './NewsPage';
export { default as Form }                  from './Form.js';
export { default as ReportsPage }           from './ReportsPage.js';
export { default as Tabs }                  from './Tabs.js';
export { default as TabFocus }              from './TabFocus.js';
export { default as ReportsDownloadsPage }  from './ReportsDownloadsPage.js';
export { default as FilterAndPagination }   from './FilterAndPagination.js';
export { default as MainPage }              from './MainPage.js';
export { default as Sidebar }               from './Sidebar.js';
export { default as Disclaimer }            from './Disclaimer.js';
export { default as Anchors }               from './Anchors.js';
export { default as HelpBanner }            from './HelpBanner.js';
export { default as StageBlocks }           from './StageBlocks';
export { default as InnovationsPage }       from './InnovationsPage';
export { default as Cookies }               from './Cookies';
export { default as Analytics }             from './Analytics';
export { default as Copy }                  from './Copy';
export { default as Hotline }               from './Hotline';



// export { default as Preloader } from './Preloader.js'; // Должен быть последним



// WEBPACK FOOTER //
// ./_src/js/index.js